import { CommonDialog } from 'components/common/dialogs';
import { ErrorBoundary } from 'components/common/error-boundary';
import { MachineStateOverview } from 'components/sections/admin-portal/machines/dialogs/settings/machine-status/machine-state-section/overview';
import { IBaseDialog } from 'interfaces/i-dialogs';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { IMachineStateCurrent } from 'lib_ts/interfaces/machine-msg/i-machine-state';
import { IReadyData } from 'lib_ts/interfaces/machine-msg/i-ready';

interface IProps extends IBaseDialog {
  ms?: IMachineStateCurrent;
  readyData?: IReadyData;
  machineID: string;
  loading: boolean;
}

export const MsDialog = (props: IProps) => {
  const { ms, readyData, machineID, loading } = props;
  return (
    <ErrorBoundary identifier="R2FStatusDialog">
      <CommonDialog
        identifier={props.identifier}
        width={RADIX.DIALOG.WIDTH.MD}
        title={`${machineID} Machine State`}
        content={
          <MachineStateOverview
            ms={ms}
            readyData={readyData}
            loading={loading}
          />
        }
        onClose={props.onClose}
      />
    </ErrorBoundary>
  );
};
